import React, { useEffect } from 'react'
import { useAppContext, useSetAppContext } from '../../redux/slices/appContext'
import ErrorBoundary from '../molecules/ErrorBoundary'
import CommentContextProvider from '../organisms/Comments/CommentContext'
import LoadingView from '../pages/LoadingView'
import {
  postNamedCommand,
  postNamedQuery
} from '../../service'
import { useFetchAbundanceEngineConfig } from '../../redux/slices/abundanceEngineContext'
import { WebsocketProvider } from '../../providers/WebsocketProvider'
import AddAccountWrapper from '../organisms/AddAccount/AddAccountWrapper'
import Layout from './Layout'
import RoutedViews from './RoutedViews'

function AppInitializer () {
  const appContext = useAppContext()
  const setAppContext = useSetAppContext()
  const fetchAbundanceEngineConfig = useFetchAbundanceEngineConfig()

  useEffect(() => {
    async function fetchNotifications (userId) {
      try {
        // The following bootstraps main areas of the site - can any of these be deferred?
        const [
          clientCount
        ] = await Promise.all([
          postNamedQuery('levels', 'searchClients', { resultType: 'total' }),
          fetchAbundanceEngineConfig()
        ])

        setAppContext({
          clientsNotifications: 0,
          notificationsCounter: 0,
          clientCount: clientCount.data?.total ?? 0
        })
      } catch (err) {
        console.error("Couldn't retrieve notifications", err)
      }
    }
    async function registerUserImpression (userId) {
      return await postNamedCommand('users', 'register-impression', {
        platform: 'swsapp-web'
      })
    }

    if (appContext.userId) {
      fetchNotifications(appContext.userId).catch(console.error)
      registerUserImpression(appContext.userId).catch(console.error)
    }
  }, [appContext.userId, setAppContext, fetchAbundanceEngineConfig])

  if (appContext.loadingAvailableDates) return <LoadingView width='100%' height='100%' />

  return (
    <ErrorBoundary name='Application level' refresh>
      <WebsocketProvider>
        <AddAccountWrapper />
        <CommentContextProvider>
          <Layout>
            <RoutedViews />
          </Layout>
        </CommentContextProvider>
      </WebsocketProvider>
    </ErrorBoundary>
  )
}

export default AppInitializer
